import { getVisitorId, isAnalyticsAllowed } from "./consent";

export const AD_IMAGE_WIDTH = 1080;
export const AD_IMAGE_HEIGHT = 1035;
export const AD_IMAGE_ASPECT = AD_IMAGE_WIDTH / AD_IMAGE_HEIGHT;

export const AD_POOLS = [
  {
    id: "emergent-1",
    headline: "Emergent — Plan, build, ship faster",
    title: "Emergent — Plan, build, ship faster",
    stubLabel: "AFFILIATE AD",
    href: "https://app.emergent.sh/?via=junian",
    emergent: true,
    adType: "EMERGENT",
    keyword: "emergent",
    neonFrameColor: "#22c55e",
    imageUrl: "https://customer-assets.emergentagent.com/job_nofap-diary/artifacts/p8b6tj1h_web%26mobile_1080x1035_2.png",
    imageFit: "contain",
    tileHeight: 320,
    mobileHeight: 160,
    matchEmergentSize: true,
  },
  {
    id: "emergent-2",
    headline: "Try Emergent — An AI workspace",
    title: "Try Emergent — An AI workspace",
    stubLabel: "AFFILIATE AD",
    href: "https://app.emergent.sh/?via=junian",
    emergent: true,
    adType: "EMERGENT",
    keyword: "emergent",
    neonFrameColor: "#22c55e",
    imageUrl: "https://customer-assets.emergentagent.com/job_nofap-diary/artifacts/mpo893hu_mobile_1080x1035_updated.png",
    imageFit: "contain",
    tileHeight: 320,
    mobileHeight: 160,
    matchEmergentSize: true,
  },
  {
    id: "donate-support-us",
    headline: "Support this project",
    title: "Support this project",
    stubLabel: "SUPPORT US",
    alt: "Support Us",
    href: "https://buymeacoffee.com/recoverylifestyle",
    emergent: false,
    adType: "DONATION",
    keyword: "donation",
    neonFrameColor: "#06b6d4",
    labelText: "Support us",
    imageUrl: "/images/support-us.png",
    imageFit: "contain",
    cropMode: "cover-top",
    cropZoom: 101,
    tileHeight: 320,
    mobileHeight: 160,
    matchEmergentSize: true,
  },
];

export const AD_BREAKPOINT_BY_ROUTE = {
  default: "md",
  "/": "md",
  "/intro": "md",
  "/week": "md",
  "/tracker": "md",
  "/diary": "md",
  "/settings": "md",
  "/privacy": "md",
  "/sponsors": "md",
};

const CLICKED_ADS_KEY = "rl_clicked_ads_by_uid_v1";

export function getAdClickUid() {
  return getConsentUid();
}

function getConsentUid() {
  if (!isAnalyticsAllowed()) return null;
  return getVisitorId();
}

function loadClickedAdsMap() {
  try {
    return JSON.parse(localStorage.getItem(CLICKED_ADS_KEY) || "{}");
  } catch (_) {
    return {};
  }
}

export function getClickedAdIdsForUser() {
  const uid = getConsentUid();
  if (!uid) return [];
  const map = loadClickedAdsMap();
  const ids = Array.isArray(map[uid]) ? map[uid] : [];
  return ids.filter((id) => typeof id === "string");
}

export function markAdClickedForUser(adId) {
  const uid = getConsentUid();
  if (!uid || !adId) return false;
  try {
    const map = loadClickedAdsMap();
    const current = new Set(Array.isArray(map[uid]) ? map[uid] : []);
    current.add(String(adId));
    map[uid] = Array.from(current);
    localStorage.setItem(CLICKED_ADS_KEY, JSON.stringify(map));
    return true;
  } catch (_) {
    return false;
  }
}

export function normalizeServerAd(serverAd) {
  const adType = String(serverAd?.adType || "GENERAL").toUpperCase();
  const headline = String(serverAd?.headline || "Sponsored").trim();
  const defaultStub = adType === "DONATION" ? "SUPPORT US" : (adType === "EMERGENT" || adType === "AFFILIATE" || adType === "AMAZON" ? "AFFILIATE AD" : "AD");
  return {
    id: String(serverAd?.id || ""),
    title: headline,
    headline,
    href: String(serverAd?.href || ""),
    imageUrl: String(serverAd?.imageUrl || "").trim(),
    adType,
    keyword: String(serverAd?.keyword || "").trim(),
    stubLabel: String(serverAd?.stubLabel || defaultStub).trim(),
    active: !!serverAd?.active,
    neonFrameColor: String(serverAd?.neonFrameColor || "#22c55e"),
    emergent: adType === "EMERGENT",
    labelText: adType,
    imageFit: "contain",
    tileHeight: 320,
    mobileHeight: 160,
    matchEmergentSize: true,
  };
}